document.addEventListener('DOMContentLoaded', function () {
  var iconList = document.querySelector('.section-header .wdt-nav-icon-list');
  if (!iconList || iconList.querySelector('.yamiriam-inline-search')) return;
  var searchTrigger = iconList.querySelector('[data-bs-target="#searchBox"]');
  if (!searchTrigger) return;
  searchTrigger.classList.add('yamiriam-search-trigger');
  var form = document.createElement('form');
  form.className = 'yamiriam-inline-search';
  form.setAttribute('action', '/search');
  form.setAttribute('method', 'get');
  form.setAttribute('role', 'search');
  form.innerHTML = '<input class="yamiriam-inline-search__input" type="search" name="q" autocomplete="off" placeholder="Rechercher un produit…" aria-label="Rechercher un produit"><button class="yamiriam-inline-search__button" type="submit" aria-label="Rechercher"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="6.5" stroke="currentColor" stroke-width="1.8"></circle><path d="M16 16l4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path></svg></button>';
  iconList.insertBefore(form, searchTrigger);
});
